import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ArrowLeftIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M10.929 11.9999L14.75 8.17891C15.164 7.76491 15.164 7.09291 14.75 6.67891C14.336 6.26491 13.664 6.26491 13.25 6.67891L8.63605 11.2929C8.24505 11.6839 8.24505 12.3169 8.63605 12.7069L13.25 17.3209C13.664 17.7349 14.336 17.7349 14.75 17.3209C15.164 16.9069 15.164 16.2349 14.75 15.8209L10.929 11.9999Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ArrowLeftIcon.propTypes = {
  sx: PropTypes.object,
};

export default ArrowLeftIcon;
